<template>
  <section >
    <main class="banner__intro-video banner-woolf" style="background-colour:#423f42;">
      <div class="banner__container">
        <p class="banner__desc">{{ banner[curLang].desc }}</p>
        <!--<a style="text-decoration:none;" :href="banner[curLang].href"><span style="display:flex;"><i class="material-icons icon" style="margin-right:8px;">play_circle</i><p class="play-cta">{{ banner[curLang].credit }}</p></span></a>-->
      </div>
    </main>
  </section>
</template>
<script>
export default {
  data() {
    return {
      curLang: this.$store.getters.getAppLang,
      showMenu: false,
      banner: {
        en: {
          tag: '',
          heading: 'Remembrance Day',
          intro: 'Remembrance Day is marked in Canada every year on 11 November. It is a day of national commemoration for the more than 118,000 Canadians who have died in military service.',
          desc: 'Browse the collection of objects, videos, activities and historical overviews below.',
          credit: 'Or watch our lesson planning guide here',
          href: '#testEN'
          // scrollMessage: ''
        },
        fr: {
          tag: '',
          heading: 'Le jour du Souvenir',
          intro: 'Au Canada, le jour du Souvenir est souligné le 11 novembre, chaque année. Il s’agit d’un jour de commémoration national en l’honneur des plus de 118 000 Canadiens et Canadiennes qui sont morts durant leur service militaire.',
          desc: 'Parcourez la collection d’objets, les vidéos, les activités et les aperçus historiques ci-dessous.',
          credit: 'Or watch our lesson planning guide here',
          href: '#testFR'
        }
      }
    };
  },
  computed: {
    bannerImage() {
      return require('@/assets/images/compressed/Art08-20110076-001-1280x906.jpg');
    }
  },
  methods: {
    toggleMenu(event) {
      console.log('toggleMenu (TheBanner.vue) event', event);
      this.showMenu = !this.showMenu;
    }
  }
};
</script>
<style lang="scss" scoped>
  @import '@/assets/scss/components.banner.scss';
</style>